import { useEffect } from "react";

import { useAnnualPromoCampaign } from "app/components/AnnualPromoModal/useAnnualPromoCampaign";
import { CampaignPromoModal } from "app/components/discountCampaign/CampaignPromoModal/CampaignPromoModal";
import type { ICampaignPromoModalProps } from "app/components/discountCampaign/CampaignPromoModal/types";
import { useCampaignDismiss } from "app/components/discountCampaign/common/hooks/useCampaignDismiss";
import { allTrackers } from "app/services/track/track";

const ANNUAL_CAMPAIGN_MODAL_STORAGE_KEY = "annual.promo.campaign.modal.last.shown";
const ANNUAL_TRACKING_PREFIX = "Discount Popup";

export const AnnualPromoCampaignModal = () => {
    const { annualPromoCtaType, onAnnualPromoCtaClick, discountModalProps } = useAnnualPromoCampaign();

    const modalInfo = useCampaignDismiss({
        type: "modal",
        isEligible: annualPromoCtaType !== null,
        onCtaClick: onAnnualPromoCtaClick,
        storageKey: ANNUAL_CAMPAIGN_MODAL_STORAGE_KEY,
        trackingPrefix: ANNUAL_TRACKING_PREFIX,
        ctaType: "4 months upgrade",
    });

    useEffect(() => {
        if (Boolean(discountModalProps) && modalInfo.isOpen) {
            allTrackers.dispatchTrackEvent("Popup", "show", "Discount Popup/4 months upgrade");
        }
    }, [discountModalProps, modalInfo.isOpen]);

    if (!discountModalProps) {
        return null;
    }

    const modalProps: ICampaignPromoModalProps = {
        ...modalInfo,
        discountEndTime: discountModalProps.discountEndTime,
        ...discountModalProps.modalConfig,
    };

    return <CampaignPromoModal {...modalProps} />;
};
